/**
 * Fabric type filter — presentational only.
 *
 * Fabric is not a Shopify option. These buttons live outside the product form,
 * carry no name, and never submit. They only show/hide colour swatches that are
 * already in the DOM, so switching fabric costs no request and no re-render.
 *
 * The active fabric is set server-side from the selected colour, so this class
 * only handles clicks. When the variant picker re-renders, the element is
 * replaced and connectedCallback runs against the new markup.
 */
class FabricFilter extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-fabric-button]');
    if (!button || !this.contains(button)) return;
    this.select(button.dataset.fabric);
  }

  select(fabric) {
    if (!fabric) return;

    this.querySelectorAll('[data-fabric-button]').forEach(button => {
      const isActive = button.dataset.fabric === fabric;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('[data-fabric-value]').forEach(item => {
      item.toggleAttribute('hidden', item.dataset.fabric !== fabric);
    });
  }
}

customElements.define('fabric-filter', FabricFilter);